import { Banner } from '@calendly/ui/components/banner';
import classNames from 'classnames';
import { forwardRef } from 'react';
import AlertSVG from './alert.svg';
const AlertIcon = () => <img src={AlertSVG} alt="" />;
const alertContentCss = "a1p3xodn";
const AlertContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(alertContentCss, props.className)} />;
});
export const AlertBanner = ({
  children
}) => <Banner type="warning" spacingBottom={8}>
    <AlertContent>
      <AlertIcon />
      <div>{children}</div>
    </AlertContent>
  </Banner>;

require("./alert_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./alert_banner.js");